import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

interface DeleteAccountModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

const DeleteAccountModal: React.FC<DeleteAccountModalProps> = ({
  show,
  onHide,
  onConfirm,
  isDeleting,
}) => {
  const [confirmText, setConfirmText] = useState("");
  const isConfirmValid = confirmText.toLowerCase() === "delete";

  const handleConfirm = () => {
    if (isConfirmValid) {
      onConfirm();
    }
  };

  const handleClose = () => {
    setConfirmText("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "2px solid #dc3545" }}>
        <Modal.Title className="text-danger">
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          Delete Account
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <h6 className="fw-bold text-danger mb-3">Warning: This action cannot be undone!</h6>
          <p className="mb-2">Deleting your account will permanently remove:</p>
          <ul className="mb-3">
            <li>Your profile and personal information</li>
            <li>All saved payment methods</li>
            <li>Your vehicle registrations</li>
            <li>All reservation history</li>
            <li>All transaction records</li>
          </ul>
          <p className="mb-3">
            <strong>Your data will be anonymized and cannot be recovered.</strong> You will need to
            create a new account to use SharePark again.
          </p>
        </div>

        <Form.Group className="mb-3">
          <Form.Label className="fw-semibold">
            To confirm, please type: <span className="text-danger">DELETE</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="Type here..."
            disabled={isDeleting}
            autoComplete="off"
          />
        </Form.Group>

        {!isConfirmValid && confirmText.length > 0 && (
          <div className="alert alert-warning small mb-0">
            Please type the exact phrase to continue
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={handleConfirm}
          disabled={!isConfirmValid || isDeleting}
        >
          {isDeleting ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Deleting Account...
            </>
          ) : (
            "Delete My Account"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteAccountModal;
